<div class="ontario-row">
  <div class="ontario-column">
    <h1 class="page-title">{{'Tab.CPOApprovedCourses' | translate}}</h1>
  </div>
  <div class="ontario-column form-input-div ontario-small-12 ontario-medium-6 ontario-large-3">
    <app-dropdown [label]="'Marketplace.TrainingProgram' | translate" [currentLang]="currentLang"
      [options]="trainingProgramOptions" [(formValue)]="courseSearchForm.trainingProgramId"
    [disabled]="isELearningSelected"></app-dropdown>
  </div>

  <div class="ontario-column form-input-div ontario-small-12 ontario-medium-6 ontario-large-3">
    <label for="TrainingProvider" class="input-label">{{'Marketplace.TrainingProvider' | translate}}</label>
    <input id="TrainingProvider" type="text" placeholder="{{'Marketplace.TrainingProviderPlaceholder' | translate}}"
      class='input-text' matInput [formControl]="trainingProviderControl" [matAutocomplete]="auto">
      <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
        @for (option of filteredProviderOptions; track option) {
          <mat-option [value]="option">
            {{option.ApplicantBusinessOperatingName}}
          </mat-option>
        }
      </mat-autocomplete>
    </div>

    <div class="ontario-column form-input-div ontario-small-12 ontario-medium-6 ontario-large-4">
      <fieldset>
        <legend>
          <label class="input-label blocked">{{"Marketplace.TrainingType" | translate}}</label>
        </legend>
        @for (type of trainingTypes; track type) {
          <button class="training-type-button"
            [class.selected]="trainingTypeIdSelected.indexOf(type.TrainingTypeId) > -1 || (trainingTypeIdSelected.length == 0 && type.TrainingTypeId == 'All' && !isELearningSelected)"
            (keyup.enter)="addToSelectedTypeId(type.TrainingTypeId)" (click)="addToSelectedTypeId(type.TrainingTypeId)">
            {{currentLang == 'en' ? type.Name : type.NameFr}}
          </button>
        }
        <!-- <ng-container *ngFor="let type of trainingTypes">
        <button class="training-type-button" *ngIf="type.TrainingTypeId !== tpAppUtils.eLearning"
          [class.selected]="trainingTypeIdSelected.indexOf(type.TrainingTypeId) > -1"
          [attr.aria-pressed]="trainingTypeIdSelected.indexOf(type.TrainingTypeId) > -1 ? 'true' : 'false'"
          (click)="addToSelectedTypeId(type.TrainingTypeId)">
          {{currentLang == 'en' ? type.Name : type.NameFr}}
        </button>
      </ng-container> -->
    </fieldset>
  </div>

  <div class="ontario-column form-input-div ontario-small-12 ontario-medium-6 ontario-large-2">
    <fieldset>
      <legend><label class="input-label blocked">{{"Marketplace.AdditionalTrainingFormat" | translate}}</label>
    </legend>
    @for (type of elearning; track type) {
      <button class="training-type-button" [class.selected]="isELearningSelected"
        (keyup.enter)="setUnsetSelectedTypes(type.TrainingTypeId)"
        (click)="setUnsetSelectedTypes(type.TrainingTypeId); addToSelectedTypeId(type.TrainingTypeId)">
        {{currentLang == 'en' ? type.Name : type.NameFr}}
      </button>
    }
    <!-- <button class="training-type-button" *ngFor="let type of elearning" [class.selected]="isELearningSelected"
    [attr.aria-pressed]="isELearningSelected ? 'true' : 'false'"
    (click)="setUnsetSelectedTypes(type.TrainingTypeId); addToSelectedTypeId(type.TrainingTypeId)">
    {{currentLang == 'en' ? type.Name : type.NameFr}}
  </button> -->
</fieldset>
</div>

<div class="ontario-column form-input-div ontario-small-12 ontario-medium-6 ontario-large-3"
  [class.disabled]="isELearningSelected">
  <label for="TrainingLocation" class="input-label">{{'Marketplace.TrainingLocation' | translate}}</label>
  <input id="TrainingLocation" type="text" class='input-text' matInput [formControl]="addressControl"
    [matAutocomplete]="autoAddress" [class.disabled]="isELearningSelected">
    <mat-autocomplete #autoAddress="matAutocomplete">
      @for (city of filteredAddressOptions; track city) {
        <mat-option [value]="city">{{city}}</mat-option>
      }
    </mat-autocomplete>
  </div>

  <div class="ontario-column form-input-div ontario-small-12 ontario-medium-6 ontario-large-3">
    <app-horizontal-radio-button-list [label]="'Marketplace.SelectRadius' | translate" [currentLang]="currentLang"
    [isDisabled]="true" [radioButtonOptions]="radiusRanges"></app-horizontal-radio-button-list>
  </div>

  <div class="ontario-column form-input-div ontario-small-12 ontario-medium-6 ontario-large-4">
    <app-date-range [(startDate)]="courseSearchForm.fromDate!" [(endDate)]="courseSearchForm.toDate!"
    [disabled]="isELearningSelected"></app-date-range>
  </div>

  <div class="ontario-column form-input-div ontario-small-12 ontario-medium-6 ontario-large-2"></div>
  <div class="ontario-column form-input-div ontario-small-12 ontario-medium-6 ontario-large-3">
    <app-numeric-input [label]="'Marketplace.TotalSeats' | translate" [(value)]="courseSearchForm.minSeatsAvailable"
    [disabled]="isELearningSelected"></app-numeric-input>
  </div>

  <div class="ontario-column form-input-div ontario-small-12 ontario-medium-12 ontario-large-3 checkbox-col">
    <app-checkbox [name]="'Marketplace.ShowListingsWithCourseFeeOnly' | translate"
    [(checked)]="courseSearchForm.hasCourseFee"></app-checkbox>
  </div>

  <div class="ontario-column form-input-div ontario-small-12 ontario-medium-12 ontario-large-3 checkbox-col">
    <app-checkbox [name]="'Marketplace.WeekendClassesOnly' | translate" [(checked)]="courseSearchForm.isWeekendsOnly"
      [disabled]="isELearningSelected">
    </app-checkbox>
  </div>

  <div class="ontario-column form-input-div ontario-small-12 ontario-medium-6 ontario-large-3"></div>
  <div class="button-row ontario-column ontario-small-12">
    <button id="search-button" (click)="searchCourses()">
      {{'Marketplace.Search' | translate}}
    </button>
    <button id="reset-button" (click)="initSearchForm()" class="ontario-button ontario-button--tertiary">
      {{'Marketplace.ResetFilters' | translate}}
    </button>
    <hr>

      @if (!isELearningSelected && totalCount>0) {
        <div class="ontario-column form-input-div ontario-small-12 ontario-medium-12 ontario-large-3"
          >
          <app-dropdown [label]="'Marketplace.SortBy' | translate" [currentLang]="currentLang" [options]="sortingOptions"
          [(formValue)]="courseSearchForm.sortingOption" (formValueChange)="searchCourses()"></app-dropdown>
        </div>
      }

      <!--<div class="ontario-column ontario-small-12 ontario-medium-12 ontario-large-3 view-selector">
      <a (click)="onChangeViewSelection(viewOptionsEnum.TILEVIEW)">
        <span class="circle-image" [ngClass]="viewType === viewOptionsEnum.TILEVIEW? 'active':'inactive'">
          <img src="assets/images/tile-view.svg" alt="Tile View" />
        </span>
      </a>
      <a (click)="onChangeViewSelection(viewOptionsEnum.LISTVIEW)">
        <span class="circle-image" [ngClass]="viewType === viewOptionsEnum.LISTVIEW? 'active':'inactive'">
          <img src="assets/images/list-view.svg" alt="List View" />
        </span>
      </a>
    </div>-->

    <div class="ontario-column ontario-small-12 ontario-medium-6 ontario-large-6 results-col ontario-padding-top-24-!"
      [class.ontario-padding-top-24-!]="!isELearningSelected" [class.ontario-padding-bottom-24-!]="isELearningSelected"
      role="status">
      @if (totalCount>0) {
        <span id="results-count">
          {{'Marketplace.Showing' | translate}} {{trainingSchedules.length}} {{'General.Of' | translate}} {{totalCount}}
          {{'Marketplace.CourseAdvertisements' | translate}}
        </span>
      }
      @if (totalCount == 0) {
        <span id="results-count">
          {{'Marketplace.NoCourseAdvertisementsFound' | translate}}
        </span>
      }
    </div>

    @if (viewType === viewOptionsEnum.LISTVIEW) {
      @for (schedule of trainingSchedules; track schedule) {
        <div class="ontario-column ontario-small-12 ontario-medium-12 ontario-large-12 selected-view"
          >
          <app-course-schedule-search-result-card [trainingSchedule]="schedule"
            [filteredFromDate]="courseSearchForm.fromDate"
          [filteredToDate]="courseSearchForm.toDate"></app-course-schedule-search-result-card>
        </div>
      }
      <div class="ontario-column ontario-small-12 buttons-container-center load-more">
        @if (showLoadMore) {
          <button (click)="loadMore()"
            class="ontario-button ontario-button--tertiary center-of-page">
            {{'General.LoadMore' | translate}}
          </button>
        }
      </div>
    }

    @if (viewType === viewOptionsEnum.TILEVIEW) {
      <div class="marketplace-tile-row selected-view">
        <div class="schedule-container ontario-row">
          @for (schedule of trainingSchedules; track schedule) {
            <div class="tile-container ontario-column ontario-small-12 ontario-medium-12 ontario-large-4">
              <app-course-schedule-tile [trainingSchedule]="schedule"> </app-course-schedule-tile>
            </div>
          }
          <div class="ontario-column ontario-small-12 buttons-container-center load-more">
            @if (showLoadMore) {
              <button (click)="loadMore()"
                class="ontario-button ontario-button--tertiary center-of-page">
                {{'General.LoadMore' | translate}}
              </button>
            }
          </div>
        </div>
      </div>
    }
  </div>

  <app-feedback-panel></app-feedback-panel>
</div>